import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { User } from 'src/model/user.model';

@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.component.html',
    styleUrls: ['./edit-user.component.scss'],
    standalone: false
})
export class EditUserComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private api = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);

  @Input() amount: number;
  @Input() username: string;
  @Input() companyId: number;

  @Input() selectedRoleId: number;
  @Output() passEntry = new EventEmitter<any>();

  newPassword: string;
  confirmPassword: string;

  newRoleId: number;

  ngOnInit(): void {
    this.newRoleId = this.selectedRoleId;
  }

  submit() {
    this.amount == undefined ? this.sharedService.openAlert('Please fill in all the fields!', ALERT_TYPE.DANGER) : this.editBasicSalary();
  }

  editBasicSalary() {
    const data = {
      "salary": this.amount
    };

    const xhr = this.api.putRequest(this.constructApi.getUpdateUserSalary(this.username), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        const user = new User(null, null, null, null, null, this.username, null, this.amount);
        this.passEntry.emit(user);

        this.reset();
        this.sharedService.openAlert("Successfully updated user salary!", ALERT_TYPE.SUCCESS);
      }
    }
  }

  changeUserPassword() {
    const error = this.validatePassword();
    if (error != "")
      this.sharedService.openAlert(error, ALERT_TYPE.DANGER)
    else
      this.updateUserPassword();
  }

  validatePassword() {
    let errorMessage = "";

    if (this.newPassword == undefined || this.confirmPassword == "" || this.newPassword == "" || this.confirmPassword == "") {
      errorMessage += "\n❌Don't leave password empty"
    }
    else {
      if (this.newPassword != this.confirmPassword) {
        errorMessage += "\n❌Password doesn't match"
      }

      if (this.newPassword.length < 10) {
        errorMessage += "\n❌Password length must be more than 10 characters"
      }
    }
    return errorMessage;
  }

  updateUserPassword() {
    const data = {
      "username": this.username,
      "password": this.newPassword
    };

    const xhr = this.api.putRequest(this.constructApi.getChangePassword(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        this.reset();
        this.sharedService.openAlert("Successfully changed password!", ALERT_TYPE.SUCCESS);
      }
    }
  }

  updateCompanyUserRole() {
    if (Number(this.selectedRoleId) == Number(this.newRoleId)) {
      this.sharedService.openAlert("No changes", ALERT_TYPE.DANGER)
    }
    else {
      const data = {
        "roleId": Number(this.newRoleId),
      };

      const xhr = this.api.putRequest(this.constructApi.getChangeCompanyUserRole(this.companyId, this.username), data);
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            this.reset();
            this.sharedService.openAlert("Successfully changed role!", ALERT_TYPE.SUCCESS);
            window.location.reload();
          }
          else
            this.sharedService.openErrorMessage(xhr)
        }
      }
    }
  }

  reset() {
    this.activeModal.close();
    this.username = "";
    this.amount = 0;
  }
}
